import axios from 'axios';
import { getLoggedInUserRole, getLoggedInUsername } from '../utils/auth';
import { throwUnlessApiSuccess } from '../utils/apiResponse';

export const FETCH_ADMINS_REQUEST = 'FETCH_ADMINS_REQUEST';
export const FETCH_ADMINS_SUCCESS = 'FETCH_ADMINS_SUCCESS';
export const FETCH_ADMINS_FAILURE = 'FETCH_ADMINS_FAILURE';
export const ADD_ADMIN_SUCCESS = 'ADD_ADMIN_SUCCESS';
export const ADD_ADMIN_FAILURE = 'ADD_ADMIN_FAILURE';
export const UPDATE_ADMIN_SUCCESS = 'UPDATE_ADMIN_SUCCESS';
export const UPDATE_ADMIN_FAILURE = 'UPDATE_ADMIN_FAILURE';
export const DELETE_ADMIN_SUCCESS = 'DELETE_ADMIN_SUCCESS';
export const DELETE_ADMIN_FAILURE = 'DELETE_ADMIN_FAILURE';
export const TOGGLE_LOCK_ADMIN_SUCCESS = 'TOGGLE_LOCK_ADMIN_SUCCESS';
export const TOGGLE_BALANCE_CHECK_ADMIN_SUCCESS = 'TOGGLE_BALANCE_CHECK_ADMIN_SUCCESS';
const base_url  = process.env.REACT_APP_API_URL_ADMIN;

export const getAdmins = () => async (dispatch) => {
  dispatch({ type: FETCH_ADMINS_REQUEST });
  try {
    const loggedInUserRole = getLoggedInUserRole();
    const loggedInUsername = getLoggedInUsername();
    const response = await axios.post(`${base_url}`, {
      apiName: 'admin',
      command: 'getAdmins',
      loggedInUserRole,
      loggedInUsername
    });
    dispatch({
      type: FETCH_ADMINS_SUCCESS,
      payload: response.data.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_ADMINS_FAILURE,
      payload: error.message || error.response?.data?.message || 'Failed to fetch admins'
    });
  }
};

export const addAdmin = (adminData) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'admin',
      command: 'addAdmin',
      ...adminData
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({
      type: ADD_ADMIN_SUCCESS,
      payload: data
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAdmin = (adminId, adminData) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'admin',
      command: 'updateAdmin',
      adminId,
      updateData: adminData
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({
      type: UPDATE_ADMIN_SUCCESS,
      payload: data
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAdmin = (adminId) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'admin',
      command: 'deleteAdmin',
      adminId
    });
    dispatch({
      type: DELETE_ADMIN_SUCCESS,
      payload: adminId
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: DELETE_ADMIN_FAILURE,
      payload: error.response?.data?.message || 'Failed to delete admin'
    });
    throw error;
  }
};

export const toggleLockAdmin = (adminId) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'admin',
      command: 'toggleLockAdmin',
      adminId
    });
    dispatch({
      type: TOGGLE_LOCK_ADMIN_SUCCESS,
      payload: response.data.data
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const toggleBalanceCheckAdmin = (adminId) => async (dispatch) => {
  try {
    const response = await axios.post(`${base_url}`, {
      apiName: 'admin',
      command: 'toggleBalanceCheckAdmin',
      adminId
    });
    const data = throwUnlessApiSuccess(response);
    dispatch({
      type: TOGGLE_BALANCE_CHECK_ADMIN_SUCCESS,
      payload: data
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};